import React from 'react'
import { getYearPercent } from '../utils/dataParsers'
import '../css/TimePoint.scss'
import { Link } from 'react-router-dom'

const TimePoint = ({ time }) => {
  const timeY = getYearPercent(time.year)
  var firstLine = time.bodyPreview || (time.body.split('.')[0] + '.')
  const bottomClass = timeY > 65 ? 'bottomAlign' : ''
  const narrKeyClass = time.narrative_keys.join().replace(',', ' ')
  // maybe use filter to create sorted industry-specific objects
  return <Link
    to={`industry/${time.industry_key}/${time.key}`}
    className={`time_point ${time.industry_key} ${narrKeyClass} ${bottomClass}`}
    style={{ 
      top: `calc(${timeY}% - 5px)`,
      transitionDelay: timeY * 0.006 + 's'
    }}
  >
    <div className='time_hover'>
      <h5 className='time_hover-heading'>{time.year}</h5>
      <p className='time_hover-body'>{firstLine}</p>
      <div className='time_hover-cta' style={{ color: '#FFF' }} to={`industry/${time.industry_key}/${time.key}`}>Learn more</div>
    </div>
  </Link>
}

export default TimePoint
